<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="scaling-svg">
    <g data-name="Icon_date">
      <path
        d="M12.6,12.857H1.4A1.416,1.416,0,0,1,0,11.429v-10A1.416,1.416,0,0,1,1.4,0H12.6A1.416,1.416,0,0,1,14,1.428v10A1.416,1.416,0,0,1,12.6,12.857ZM2.1,1.428a.708.708,0,0,0-.7.714v8.572a.708.708,0,0,0,.7.714h9.8a.708.708,0,0,0,.7-.714V2.143a.708.708,0,0,0-.7-.714Z"
        transform="translate(0 1.143)"
      />
      <path
        d="M0,.714A.7.7,0,0,1,.686,0a.7.7,0,0,1,.686.714V2.143a.7.7,0,0,1-.686.714A.7.7,0,0,1,0,2.143Z"
        transform="translate(3.157)"
      />
      <path
        data-name="Path"
        d="M0,.714A.7.7,0,0,1,.686,0a.7.7,0,0,1,.686.714V2.143a.7.7,0,0,1-.686.714A.7.7,0,0,1,0,2.143Z"
        transform="translate(8.647)"
      />
      <path
        data-name="Path"
        d="M.149,3.1.487,0H3.768V1.009H1.44l-.145,1.31a1.785,1.785,0,0,1,.881-.23,1.654,1.654,0,0,1,1.311.54,2.213,2.213,0,0,1,.474,1.511A2.28,2.28,0,0,1,3.72,5.2a1.729,1.729,0,0,1-.684.724,2.086,2.086,0,0,1-1.054.255A2.216,2.216,0,0,1,1,5.956a1.8,1.8,0,0,1-.72-.632A1.776,1.776,0,0,1,0,4.4H1.15a.924.924,0,0,0,.253.594.8.8,0,0,0,.575.209.706.706,0,0,0,.607-.293A1.418,1.418,0,0,0,2.8,4.072a1.16,1.16,0,0,0-.245-.8A.882.882,0,0,0,1.858,3a.98.98,0,0,0-.672.226l-.113.109Z"
        transform="translate(4.529 5)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DateIcon extends Vue {}
</script>

<style></style>
